import React from 'react';
import { m } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
import { SectionTag } from '../ui/SectionTag';
import { testimonials } from '../../data/content';
export function Testimonials() {
  return <section className="bg-cream py-10 sm:py-14" data-id="element-158" data-mp="3mg0mup53sxgg">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-159" data-mp="3r7infc37sw0w">
        <SectionTag data-id="element-160" data-mp="3r8tr7bwnu3s0">Testimonios</SectionTag>
        <h2 className="mt-5 font-heading text-3xl font-extrabold uppercase leading-tight text-navy sm:text-4xl" data-id="element-161" data-mp="1hizmdr90o8">
          Lo que dicen profesores como tú
        </h2>
      </div>

      <div className="mx-auto mt-8 grid max-w-5xl gap-4 px-4 sm:grid-cols-2 sm:px-6" data-id="element-162" data-mp="44nlqk1ns9py">
        {testimonials.map((t, i) => <m.div key={t.name} initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: i % 2 * 0.08
      }} className="flex flex-col rounded-2xl border border-navy/10 bg-white p-6" data-id="element-163" data-mp="e1ilf69o4g5t" data-mpi={i}>
            <QuoteIcon size={22} className="text-orange" data-id="element-164" data-mp="1sm3yo1s1ciit" />
            <p className="mt-3 flex-1 text-sm leading-relaxed text-ink" data-id="element-165" data-mp="1ntatxdwkha6q">"{t.text}"</p>
            <div className="mt-4 border-t border-navy/10 pt-3" data-id="element-166" data-mp="1iupuhgp52ujc">
              <p className="text-sm font-semibold text-navy" data-id="element-167" data-mp="1iuzi4xmpoplv">{t.name}</p>
              <p className="text-xs text-muted" data-id="element-168" data-mp="1eu5ywhk7ryzb">{t.role}</p>
            </div>
          </m.div>)}
      </div>
    </section>;
}